import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { kebabCase } from 'lodash';
import { Text } from 'components/core/Text';

export default function ContentBlock({ className, steps = [], links = [] }) {
	return (
		<div className={classnames(className, 'content-block')}>
			<div className="steps-list">
				{steps.map((step, i) => (
					<div className="step" key={kebabCase(step.title)}>
						<div className="step-number-bubble">
							<div className="step-number">
								{i + 1}
							</div>
						</div>
						<Text strong>
							{step.title}
						</Text>
						<Text light size="small">
							{step.description}
						</Text>
					</div>
				))}
			</div>
			<div className="outbound-links">
				{links.map((link, i) => (
					<div
						key={i} // eslint-disable-line react/no-array-index-key
					>
						{link}
					</div>
				))}
			</div>
		</div>
	);
}

ContentBlock.propTypes = {
	className: PropTypes.string,
	steps: PropTypes.arrayOf(PropTypes.shape({
		title: PropTypes.string,
		description: PropTypes.string
	})),
	links: PropTypes.arrayOf(PropTypes.node)
};

